import { render } from "./VRInfo.vue?vue&type=template&id=2fd5616c"
import script from "./VRInfo.vue?vue&type=script&lang=js"
export * from "./VRInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__